import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ComponentHeader } from 'src/app/models/componentheader.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import { HeaderButton } from 'src/app/models/headerbtn.model';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FirstTimeValue, UtilService } from 'src/app/services/util.service';
import { Observable } from 'rxjs';
import {
  SchoolConfig,
  SchoolInfoBundle,
} from 'src/app/models/school/schooladminitem.model';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import * as introJs from 'intro.js/intro.js';
import { BillingAccountService } from 'src/app/services/BillingAccount/billing-account.service';
import { ToastrService } from 'ngx-toastr';
import { Device } from 'src/app/models/devicetype';
import { AdminAction } from 'src/app/models/adminaction.model';

declare var $: any;
declare var deferredPrompt: any;
declare var showInstallBtn: any;
//import { FeatureGroups } from 'src/app/models/billing/BillingAccountInfo';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, AfterViewInit {
  //breadcrumb :  BreadCrumb[];
  //headerbtn : HeaderButton[];
  @ViewChild('searchForm') searchForm: ElementRef;
  @ViewChild('actionslink') actionsLink: ElementRef;
  @ViewChild('userProfileModal') userProfileModal: ElementRef;
  @ViewChild('moreModal') moreModal: ElementRef;
  @ViewChild('allCoursesSearchRadioButton')
  allCoursesSearchRadioButton: ElementRef;
  @ViewChild('myCoursesSearchRadioButton')
  myCoursesSearchRadioButton: ElementRef;
  userimageurl: any;
  //schoolConfig: SchoolConfig = new SchoolConfig();
  //schoolInfoLoaded = false;
  // remdays = 0;
  // remhours=0;
  // remDate="";
  // tier=1;
  toursteps: any[] = [];
  showBilling = false;
  //schoollogourl: string;
  introJS = introJs();
  user: any = {};
  schoolInfoBundle: SchoolInfoBundle;
  isOnline: boolean;
  //deferredPrompt: any;
  //showInstallBtn = false;
  logoUrl = '';
  isAndriod = false;
  isIOS = false;
  isMobile = false;
  showIOSpopUp = false;
  hasPendingBills: any = false;
  @ViewChild('displayBtn') displayBtn: any;

  constructor(
    public headerinfo: ComponentheaderService,
    public useraccessservice: UseraccessserviceService,
    public router: Router,
    public util: UtilService,
    private activatedroute: ActivatedRoute,
    private toastr: ToastrService,
    private modulemanager: ModulemanagementService,
    private billService: BillingAccountService
  ) {
    //this line has to come as early as possible so that child components can overwrite the header display
    this.headerinfo.setHeaderDisplay(
      'Home',
      [{ displaytext: 'Home', route: '/' }],
      []
    );

    // window.addEventListener("beforeinstallprompt", (event) => {
    //   this.beforeinstallprompt(event);
    // });
  }
  ngAfterViewInit(): void {
    //this.actionsDropdownClicked();
  }

  get showInstallBtn(){
    return showInstallBtn;
  }

  async ngOnInit() {
    this.schoolInfoBundle = await this.util.getStaticSchoolInfoBundle();

    this.isMobile = this.util.mobile();
    //TEST DVELOPMENT CODE

    //await this.util.saveschoolconfig();
    //this.schoolConfig = this.util.getschoolconfig();
    // this.schoollogourl = this.headerinfo.school.logoImg + '?' + (new Date()).getTime();
    //this.schoollogourl = this.headerinfo.school.logoImg;
    const icon = document.querySelector('[rel="icon"]');
    icon.setAttribute('href', this.util.schoolInfoBundle.schoolInfo.logoImg);
    // if (this.billingAccountService.hasFeature(this.schoolConfig.features, FeatureGroups.logo) {

    //   // icon.setAttribute('href', this.headerinfo.school.logoImg + '?' + (new Date()).getTime());
    //   icon.setAttribute('href', this.headerinfo.school.logoImg);
    // }
    // else{
    //   icon.setAttribute('href', '/assets/img/brand/favicon.png');//doing this here so that it won't first show the impata icon before replacing it with the school's logo
    // }

    //this.schoolInfoLoaded = true;
    // let hi=   this.headerinfo.headerDisplay.adminactions;
    // console.log("Header Info", hi);
    //setup the component header
    // document.addEventListener('click', this.actionsDropdownClicked.bind(this));
    this.user = await this.useraccessservice.isAlive().toPromise();
    //debugger;
    if (this.user) {
      this.hasPendingBills = await this.billService.checkForPendingBills().toPromise();

      this.setimage();

      await this.util
        .checkUserIsSubdomainAdmin()
        .toPromise()
        .then((response: boolean) => {
          this.showBilling = response;
          this.util.userSubDomainAdminStatus = response;
          // console.log(this.showBilling)
        });

      const enrolled: any = await this.modulemanager
        .userhasenrollmentinschool()
        .toPromise();
      if (!enrolled) {
        this.allCoursesSearchRadioButton.nativeElement.checked = true;
        this.myCoursesSearchRadioButton.nativeElement.checked = false;
      } else {
        this.allCoursesSearchRadioButton.nativeElement.checked = false;
        this.myCoursesSearchRadioButton.nativeElement.checked = true;
      }

      this.util.isFirstTime$.subscribe((val: FirstTimeValue) => {   
        if (val == FirstTimeValue.True)
          $('#firtTimeModal').modal('show');
        else if (val == FirstTimeValue.False)
          $('#firtTimeModal').modal('hide');        
      });

      if(this.util.getFirstTimeValue() == FirstTimeValue.Undefined)
        this.util.setFirstTime(this.user.firstTime);
    } else if (this.useraccessservice.getCurrentUserToken()) {
      //if user token exists but is expired or not valid on the server for whatever reason
      this.useraccessservice.userLogout();
    }
    
    if (this.headerinfo.taketour || this.util.getFirstTimeValue() == FirstTimeValue.True) {
      $('#firtTimeModal').modal('show');
    }

    this.updateOnlineStatus();
    window.addEventListener('online', this.updateOnlineStatus.bind(this));
    window.addEventListener('offline', this.updateOnlineStatus.bind(this));
  }
  async setimage() {
    // this.userimageurl = (await this.useraccessservice.getuserprofileimage(0).toPromise()).url + '?' + (new Date()).getTime();
    this.userimageurl = (
      await this.useraccessservice.getuserprofileimage(0).toPromise()
    ).url;
  }

  isOnPage(path: string): boolean {
    return this.router.url.includes(path);
  }

  search(searchForm) {
    console.log(searchForm.value);
    if (searchForm.value.searchstring) {
      let options = document.getElementsByName(
        `${
          searchForm === this.searchForm
            ? 'search-form__searchoptions'
            : 'search-form--sm__searchoptions'
        }`
      );
      let searchfilter = '';
      let i = 0;
      //debugger
      for (i; i < options.length; i++) {
        var option = options[i] as HTMLInputElement;
        //debugger
        if (option.checked) searchfilter = option.value;
      }
      this.router.navigate(['searchmodules'], {
        relativeTo: this.activatedroute,
        queryParams: {
          searchstring: searchForm.value.searchstring,
          filter: searchfilter,
        },
      });
    }
  }

  toggleUserProfileModalState() {
    const userProfileModal = this.userProfileModal.nativeElement;

    const hide = () => {
      userProfileModal.classList.remove('show');
      userProfileModal.classList.add('hide');
      document.removeEventListener('click', hide);
    };

    const show = () => {
      userProfileModal.classList.remove('hide');
      userProfileModal.classList.add('show');
      setTimeout(() => document.addEventListener('click', hide), 1);
    };

    if (userProfileModal.classList.contains('show')) {
      hide();
    } else {
      show();
    }
  }

  toggleMoreModalState() {
    const moreModal = this.moreModal.nativeElement;

    const hide = () => {
      moreModal.classList.remove('visible');
      moreModal.classList.remove('in-view');
      moreModal.classList.add('invisible');
      moreModal.classList.add('below-view');
      document.removeEventListener('click', hide);
    };

    const show = () => {
      moreModal.classList.remove('invisible');
      moreModal.classList.remove('below-view');
      moreModal.classList.add('visible');
      moreModal.classList.add('in-view');
      setTimeout(() => document.addEventListener('click', hide), 1);
    };

    if (moreModal.classList.contains('visible')) {
      hide();
    } else {
      show();
    }
  }

  actionsDropdownClicked() {
    setTimeout(
      (() => {
        if (
          this.actionsLink.nativeElement.getAttribute('aria-expanded') == 'true'
        ) {
          $(this.actionsLink.nativeElement.querySelector('i')).addClass(
            'fa-caret-up'
          );
          $(this.actionsLink.nativeElement.querySelector('i')).removeClass(
            'fa-caret-down'
          );
        } else {
          $(this.actionsLink.nativeElement.querySelector('i')).addClass(
            'fa-caret-down'
          );
          $(this.actionsLink.nativeElement.querySelector('i')).removeClass(
            'fa-caret-up'
          );
        }
      }).bind(this),
      1
    );
  }
  taketour() {
    this.toursteps = [
      {
        element: '#step0',
        intro: 'Takes you to your <b>Dashboard</b>',
        position: 'right',
      },
      {
        element: '#step2',
        intro: 'Takes you to <b>School Dashboard</b>',
        position: 'left',
      },      
      {
        element: '#step4',
        intro: 'Take tour of Page',
        position: 'right',
      },
      {
        element: '#searchcourses1',
        intro:
          "Type <b>course code</b> or <b>course name</b> to search for course among registered courses or all the school's courses",
        position: 'bottom',
      },

      {
        element: '#profiledd',
        intro: 'Click to View Profile or Logout',
        position: 'bottom',
      }
    ];
    
    if(this.showBilling){
      let items  = [
        {
        element: '#step1',
        intro: 'Click to View Admin Options',
        position: 'left',
      },
      {
        element: '#step3a',
        intro: 'Setup School Infomation',
        position: 'top',
      },
      {
        element: '#step3',
        intro: 'View/Setup School Account Details, and School Plan',
        position: 'top',
      },
      {
        element: '#stepbilling',
        intro: 'View Daily/Monthly Billings',
        position: 'top'
      },
      {
        element: '#collectionsLink',
        intro: 'View Payments Received ',
        position: 'top',
      },
      {
        element: '#step40',
        intro: 'School Packages',
        position: 'top'
     },
      ]
      this.toursteps.push(...items);
    }

    const enabledTourSteps = [];
    for(let i = 0; i < this.toursteps.length; i++){
      if(document.querySelector(this.toursteps[i].element)){
        enabledTourSteps.push(this.toursteps[i]);
      }
    }

    this.introJS.setOptions({
      steps: enabledTourSteps,
      showProgress: false,
      exitOnOverlayClick: true,
      exitOnEsc: true,
      skipLabel: 'Exit',
    });
    let otheroptions = this.headerinfo.headerDisplay.touroptions;
    this.introJS.addSteps(otheroptions);
    this.introJS.start();
  }

  notifyFeatureNotAvailable(action: AdminAction) {
    if(action.isTableAction)
      this.toastr.info("Select row(s) to perform action")
    else
      this.util.notifyFeatureNotAvailable(action.featureGroup);
  }

  //@HostListener('window:beforeinstallprompt', ['$event'])
  // beforeinstallprompt(e: any): any {
  //   // Prevent browser from showing default prompt
  //   e.preventDefault();
  //   // Save the event reference
  //   deferredPrompt = e;
  //   this.showInstallBtn = true;
  // }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = this.util.mobile();
    this.updateOnlineStatus();
  }
  async addToHomeScreen() {
    if (this.isAndriod) {
      console.log('Android');
      //showInstallBtn = false;
      const promptResult = await deferredPrompt.prompt();
      if(promptResult.outcome == 'accepted'){
        showInstallBtn = false;
      }
    }else if (this.isIOS){
      this.showIOSpopUp=true;
    }

  }
  private updateOnlineStatus(): void {
    this.isOnline = window.navigator.onLine;
    // if (this.isOnline) {
    //   this.showInstallBtn = true;
    // } else {
    //   this.showInstallBtn = false;
    // }
    this.isPwaMode();
  }
  isPwaMode() {
    if (deferredPrompt === null || deferredPrompt === undefined || window.matchMedia('(display-mode: standalone)').matches) {
      showInstallBtn = false;
    }
    let device = this.util.getDeviceType();
    console.log("Device: "+device);

    if (device == Device.Android) {
      this.isAndriod = true;
      this.isIOS = false;
    } else if (device == Device.IOS) {
      this.isIOS = true;
      this.isAndriod = false;
      if(!window.matchMedia('(display-mode: standalone)').matches){
        showInstallBtn = true;
      }
    } else {
      showInstallBtn = false;
    }
  }

  closeFloatCard() {
    this.displayBtn.nativeElement.style = 'display:none;';
    this.showIOSpopUp = false;
  }
  async closefirstTimeModal(){
    $('#firtTimeModal').modal('hide');
    await this.useraccessservice.updateUserFirstTime(false).toPromise()
    this.taketour();
  }

  gotoContactUs(){
    this.router.navigate(['/site/schoolhome'], {
      fragment: 'contact'
    });
  }
}
